import AMask from './Mask.vue';
export default AMask;


// WEBPACK FOOTER //
// ./src/packages/Mask/index.js